/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ converted: NonNullable<unknown>, total: NonNullable<unknown> }} Read_Along_Pages_Not_ConvertedInputs */

const en_read_along_pages_not_converted = /** @type {(inputs: Read_Along_Pages_Not_ConvertedInputs) => LocalizedString} */ (i) => {const convertedPlural = registry.plural("en", i?.converted, {});
	if (convertedPlural === "one") return /** @type {LocalizedString} */ (`Only the first page of ${i?.total} was converted.`);
	if (convertedPlural === "other") return /** @type {LocalizedString} */ (`Only the first ${i?.converted} of ${i?.total} pages were converted.`);
	return /** @type {LocalizedString} */ ("read_along_pages_not_converted");
};

const es_read_along_pages_not_converted = /** @type {(inputs: Read_Along_Pages_Not_ConvertedInputs) => LocalizedString} */ (i) => {const convertedPlural = registry.plural("es", i?.converted, {});
	if (convertedPlural === "one") return /** @type {LocalizedString} */ (`Solo se convirtió la primera de ${i?.total} páginas.`);
	if (convertedPlural === "other") return /** @type {LocalizedString} */ (`Solo se convirtieron las primeras ${i?.converted} de ${i?.total} páginas.`);
	return /** @type {LocalizedString} */ ("read_along_pages_not_converted");
};

/**
* | convertedPlural | output |
* | --- | --- |
* | "one" | "Only the first page of {total} was converted." |
* | "other" | "Only the first {converted} of {total} pages were converted." |
*
* @param {Read_Along_Pages_Not_ConvertedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_pages_not_converted = /** @type {((inputs: Read_Along_Pages_Not_ConvertedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Pages_Not_ConvertedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_pages_not_converted(inputs)
	return en_read_along_pages_not_converted(inputs)
});